<template>
  <div v-if="membershipPagerLoaded">
    <div class="tab-header mb-3">
      <h3 class="page-header-2">Membership</h3>
      <SeraButton @click="toggleModal">
        Add Membership <PlusIcon class="h-3 w-3 ml-2"
      /></SeraButton>
    </div>
    <div class="p-3 mt-3">
      <CustomerMembershipDetails
        v-for="membership in membershipData"
        :key="membership.id"
        :membership="membership"
        @edit-membership="editUserMembership(membership)"
      />
      <div v-if="!membershipData.length" class="no-results-message">
        <i class="fas fa-heart-broken"></i>
        Not a Member
      </div>
    </div>
    <PaginationControls :pager="membershipPager" @update:data="updateData" />
    <CustomerMembershipModal
      v-if="modal"
      :membership="selectedMembership"
      @hide-modal="toggleModal"
      @action-success="refreshUser"
    />
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import { mapActions, mapState } from "vuex";
import Pagination from "@/lib/pagination";

import PaginationControls from "@/components/PaginationControls.vue";
import SeraButton from "@/components/Seranova/Buttons/Button.vue";
import PlusIcon from "@/images/plus-outline.svg?component";
import CustomerMembershipModal from "@/MembershipModal/CustomerMembershipModal.vue";
import CustomerMembershipDetails from "./CustomerMembershipDetails.vue";

export default {
  components: {
    PaginationControls,
    PlusIcon,
    SeraButton,
    CustomerMembershipDetails,
    CustomerMembershipModal
  },
  data() {
    return {
      modal: false,
      selectedMembership: {},
      membershipData: [],
      membershipPager: {},
      totalMembership: 0
    };
  },
  computed: {
    ...mapState(["currentUser"]),
    membershipPagerLoaded() {
      return !isEmpty(this.membershipPager);
    }
  },
  watch: {
    currentUser() {
      this.init();
    }
  },
  mounted() {
    // Get up to date memberships when opening tab
    if (this.currentUser) {
      this.init();
    }
  },
  methods: {
    ...mapActions(["fetchUser"]),
    toggleModal() {
      this.modal = !this.modal;
      if (!this.modal) {
        this.selectedMembership = {};
      }
    },
    refreshUser() {
      this.fetchUser({ id: this.currentUser.id });
    },
    editUserMembership(membership) {
      this.selectedMembership = membership;
      this.toggleModal();
    },
    async fetchData() {
      const response = await this.membershipPager.getData();
      if (response) {
        this.membershipData = response.data.data;
        this.totalMembership =
          response.data.meta?.pagination.total_objects || 0;
      }
    },
    updateData(val) {
      this.membershipData = val;
    },
    init() {
      this.membershipPager = new Pagination({
        baseURL: this.currentUser.links.fetch_memberships_paginated,
        perPage: 10
      });
      this.fetchData();
    }
  }
};
</script>

<style lang="scss" scoped>
.no-results {
  color: var(--gray);
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  i {
    font-size: 4rem;
    margin-bottom: 10px;
  }
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
